
import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import { RiHomeFill, RiSendPlaneFill, RiHeartLine } from 'react-icons/ri';
import { IoIosArrowForward, IoMdLogOut } from 'react-icons/io';
import { BiMessageAdd } from 'react-icons/bi'
import { MdOutlineExplore } from 'react-icons/md'
import { FiUpload } from 'react-icons/fi'
import { FaUserFriends } from 'react-icons/fa'
import logo from '../assets/logo.png';
import { categories } from '../utils/data';

const isNotActiveStyle = 'flex items-center px-5 gap-3 text-gray-500 hover:text-black transition-all duration-200 ease-in-out capitalize';
const isActiveStyle = 'flex items-center px-5 gap-3 font-extrabold border-r-2 border-black  transition-all duration-200 ease-in-out capitalize';


const Sidebar = ({ closeToggle, user }) => {

  const handleCloseSidebar = () => {
    if (closeToggle) closeToggle(false);
  };


  return (
    <div className="flex flex-col justify-between bg-white h-full overflow-y-scroll min-w-210 hide-scrollbar">
      <div className="flex flex-col">
        <Link
          to="/"
          className="flex px-5 gap-2 my-6 pt-1 w-190 items-center"
          onClick={handleCloseSidebar}
        >
          <img src={logo} height={100} width={100} alt="logo" />
        </Link>
        <div className="flex flex-col gap-5">

          <NavLink
            to="/"
            className={({ isActive }) => (isActive ? isActiveStyle : isNotActiveStyle)}
            onClick={handleCloseSidebar}
          >
            <RiHomeFill />
            Home
          </NavLink>

          <NavLink
            to="/friends"
            className={({ isActive }) => (isActive ? isActiveStyle : isNotActiveStyle)}
            onClick={handleCloseSidebar}
          >
            <FaUserFriends />
            Friends
          </NavLink>

          {/* <NavLink
            to="/messages"
            className={({ isActive }) => (isActive ? isActiveStyle : isNotActiveStyle)}
            onClick={handleCloseSidebar}
          >
            <RiSendPlaneFill />
            Messages
          </NavLink> */}

          <NavLink
            to="/create-pin"
            className={({ isActive }) => (isActive ? isActiveStyle : isNotActiveStyle)}
            onClick={handleCloseSidebar}
          >
            <BiMessageAdd />
            Create Post
          </NavLink>


          <NavLink
            to="/explore"
            className={({ isActive }) => (isActive ? isActiveStyle : isNotActiveStyle)}
            onClick={handleCloseSidebar}
          >
            <MdOutlineExplore />
            Explore
          </NavLink>

          {/* <NavLink
            to="/inbox"
            className={({ isActive }) => (isActive ? isActiveStyle : isNotActiveStyle)}
            onClick={handleCloseSidebar}
          >
            <RiHeartLine />
            Inbox
          </NavLink> */}
          {user && (
            <NavLink
              to={`saved/${user._id}`}
              className={({ isActive }) => (isActive ? isActiveStyle : isNotActiveStyle)}
              onClick={handleCloseSidebar}
            >
              <FiUpload />
              Saved
            </NavLink>
          )}


          {/* <NavLink
            to="/login"
            className={({ isActive }) => (isActive ? isActiveStyle : isNotActiveStyle)}
            onClick={() => {handleCloseSidebar(); localStorage.clear()}}
          >
            <IoMdLogOut />
            Logout
          </NavLink> */}


          {/* <h3 className="mt-2 px-5 text-base 2xl:text-xl">Discover cateogries</h3> */}
          {/* {categories.slice(0, categories.length - 1).map((category) => (
            <NavLink
              to={`/category/${category.name}`}
              className={({ isActive }) => (isActive ? isActiveStyle : isNotActiveStyle)}
              onClick={handleCloseSidebar}
              key={category.name}
            >
              <img src={category.image} className="w-8 h-8 rounded-full shadow-sm" />
              {category.name}
            </NavLink>
          ))} */}
        </div>
      </div>
      {user && (
        <Link
          to={`user-profile/${user._id}`}
          className="flex my-5 mb-3 gap-2 p-2 items-center bg-white rounded-lg shadow-lg mx-3"
          onClick={handleCloseSidebar}
        >
          <img src={user.image} className="w-10 h-10 rounded-full" alt="user-profile" />
          <p>{user.userName}</p>
          <IoIosArrowForward />
        </Link>
      )}
    </div>
  )
}

export default Sidebar;